import { getRenderCountData, incrementRenderCount } from "../data";
import { LocalSettings } from "../../settings";
import { AADetectionResults } from "../types";

/**
 * renderAllowed checks if readership link could be rendered by next rules:
 * - location url is not one from allowlisted
 * - PV render count data met requirement based on the page_views_to_render setting
 * @param {LocalSettings} settings - the readership link local settings
 * @returns {boolean} - if rendering allowed based on settings
 * */
export const renderAllowed = (settings: LocalSettings): boolean => {
  if (!settings) {
    return false;
  }

  const { allowlisted_urls, page_views_to_render } = settings;

  const locationURL = window.location.href;
  if (allowlisted_urls?.some((url) => locationURL.startsWith(url))) {
    return false;
  }

  if (getRenderCountData() < page_views_to_render) {
    incrementRenderCount();
    return false;
  }

  return true;
};

export const adsAllowed = (
  aaDetectionResults: AADetectionResults,
  renderToAAUsers?: boolean,
): boolean => {
  return (
    aaDetectionResults &&
    (!aaDetectionResults.ab ||
      (aaDetectionResults.acceptable && !renderToAAUsers))
  );
};
